module.exports = __webpack_public_path__ + "static/media/team-right-image.b860c214.png";